var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c("el-form-item", { attrs: { label: "已读用户" } }, [
            _vm._v(" " + _vm._s(_vm.getStr(_vm.childData.hadRead)) + " ")
          ]),
          _c("el-form-item", { attrs: { label: "未读用户" } }, [
            _vm._v(" " + _vm._s(_vm.getStr(_vm.childData.unRead)) + " ")
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCancle } },
            [_vm._v(_vm._s(_vm.$t("button.close")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }